<script setup lang="ts">
  import { type RouteLocationRaw } from 'vue-router'

  defineOptions({ name: 'GButton' })

  withDefaults(defineProps<{
    type?: 'button' | 'submit' | 'reset' | undefined,
    disabled?: boolean,
    loading?: boolean,
    to?: RouteLocationRaw,
    href?: string,
    target?: string,
    download?: boolean,
  }>(), {
    type: 'submit',
    target: '_self',
    href: undefined,
    to: undefined,
  })
</script>

<template>
  <router-link
    v-if="to && !disabled && !loading"
    :to="to"
    :target="target"
    class="btn">
    <slot></slot>
  </router-link>
  <a
    v-else-if="href && !disabled && !loading"
    :href="href"
    :target="target"
    class="btn"
    rel="noopener noreferrer">
    <slot></slot>
  </a>
  <button
    v-else
    :type="type"
    :disabled="disabled || loading"
    :class="{'loading': loading}"
    class="btn">
    <slot></slot>
  </button>
</template>

<style lang="postcss" scoped>
.btn {
  @apply px-4 py-2 inline-block whitespace-nowrap text-sm border rounded-md;
  &:disabled {
    @apply cursor-not-allowed text-black bg-gray-100 border-gray-100;
  }
}
.btn-primary {
  @apply bg-primary-500 border-primary-500 text-black ;
}
.btn-outline-primary {
  @apply bg-gray-50 text-primary-500 border-primary-500;
}
.btn-red {
  @apply bg-red-500 border-red-500 text-white;
}
.btn-outline-red {
  @apply bg-white border-red-500 text-red-500;
}
.btn-gray {
  @apply bg-gray-500 border-gray-500 text-white;
}

.btn-gray-200 {
  @apply bg-gray-200 border-gray-200 text-black;
}
</style>
